import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Small breadcrumb shown at the top of every admin sub-page.
 * Pops the visitor back to the /admin hub without needing to know the URL.
 */
export default function AdminBreadcrumb({ current }) {
  return (
    <nav
      aria-label="Admin breadcrumb"
      className="flex items-center gap-2 text-xs uppercase tracking-widest text-[#84A98C] mb-6"
      data-testid="admin-breadcrumb"
    >
      <Link
        to="/admin"
        className="inline-flex items-center gap-1 text-[#52796F] hover:text-[#D4AF37] transition-colors"
        data-testid="admin-breadcrumb-home"
      >
        <ArrowLeft className="w-3.5 h-3.5" strokeWidth={1.5} />
        Admin
      </Link>
      {current && (
        <>
          <span aria-hidden="true">/</span>
          <span className="text-[#354F52]">{current}</span>
        </>
      )}
    </nav>
  );
}
